/**
 * Generated from ch5_p01.fla
 */
export function ch5_p01(this: Ich5_p01) {
	const lamb = this.lamb;
	if (!lamb[0] && lamb.elementFactory) {
		lamb[0] = lamb.elementFactory(0,undefined);
	}
	if (lamb[0]) {
		ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_lamb.call(lamb[0] as Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_lamb);
		lamb[0].x = 700;
		lamb[0].y = 550;
		lamb[0].width = 209.00;
		lamb[0].height = 281.00;
		lamb[0].alpha = 1;
		if (lamb[0].onLayout) lamb[0].onLayout();
	}
	if (!lamb[1] && lamb.elementFactory) {
		lamb[1] = lamb.elementFactory(1,undefined);
	}
	if (lamb[1]) {
		ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p02_lamb.call(lamb[1] as Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p02_lamb);
		lamb[1].x = 686.75;
		lamb[1].y = 631.5;
		lamb[1].width = 233.50;
		lamb[1].height = 221.00;
		lamb[1].alpha = 1;
		if (lamb[1].onLayout) lamb[1].onLayout();
	}
	const bg = this.bg;
	ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const hollyBack = this.hollyBack;
	ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_hollyback.call(this.hollyBack);
	hollyBack.x = 812.25;
	hollyBack.y = 398;
	hollyBack.width = 133.50;
	hollyBack.height = 145.00;
	hollyBack.alpha = 1.00;
	if (hollyBack.onLayout) hollyBack.onLayout();
	const penSide_closed = this.penSide_closed;
	ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_penside.call(this.penSide_closed);
	penSide_closed.x = 669;
	penSide_closed.y = 555.5;
	penSide_closed.width = 441.00;
	penSide_closed.height = 379.00;
	penSide_closed.alpha = 1.00;
	if (penSide_closed.onLayout) penSide_closed.onLayout();
	const hollyFront = this.hollyFront;
	ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_hollyfront.call(this.hollyFront);
	hollyFront.x = 897.75;
	hollyFront.y = 485.25;
	hollyFront.width = 235.50;
	hollyFront.height = 492.50;
	hollyFront.alpha = 1.00;
	if (hollyFront.onLayout) hollyFront.onLayout();
	const penFront = this.penFront;
	ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_penfront.call(this.penFront);
	penFront.x = 357.5;
	penFront.y = 609.75;
	penFront.width = 715.00;
	penFront.height = 305.50;
	penFront.alpha = 1.00;
	if (penFront.onLayout) penFront.onLayout();
	const penSide_open = this.penSide_open;
	ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p02_penside.call(this.penSide_open);
	penSide_open.x = 800;
	penSide_open.y = 585;
	penSide_open.width = 179.00;
	penSide_open.height = 297.00;
	penSide_open.alpha = 1.00;
	if (penSide_open.onLayout) penSide_open.onLayout();
	const holly = this.holly;
	ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p02_holly.call(this.holly);
	holly.x = 1095;
	holly.y = 444;
	holly.width = 263.00;
	holly.height = 648.00;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const frameRight = this.frameRight;
	ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 356.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 344.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_wcframeLlinescopy.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 378.5;
	linesLeft.width = 107.00;
	linesLeft.height = 749.00;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	const linesRight = this.linesRight;
	ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_wcframeRlines.call(this.linesRight);
	linesRight.x = 1664;
	linesRight.y = 609;
	linesRight.width = 191.50;
	linesRight.height = 246.00;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	return this;
}
function ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_bg(this: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp5_p01_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_hollyback(this: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_hollyback) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp5_p01_hollyback", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_lamb(this: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_lamb) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp5_p01_lamb", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_penside(this: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_penside) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp5_p01_penside", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_hollyfront(this: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_hollyfront) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp5_p01_hollyfront", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p02_lamb(this: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p02_lamb) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp5_p02_lamb", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_penfront(this: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_penfront) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp5_p01_penfront", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p02_penside(this: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p02_penside) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp5_p02_penside", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p02_holly(this: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p02_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp5_p02_holly", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_wcframeRframe(this: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_wcframeLframe(this: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_wcframeLlinescopy(this: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_wcframeLlinescopy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Llinescopy", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_wcframeRlines(this: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_wcframeRlines) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rlines", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich5_p01Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich5_p01Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich5_p01Sprite extends Ich5_p01Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich5_p01Text extends Ich5_p01Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich5_p01Polygon extends Array<number> {
}
interface Ich5_p01 {
	readonly lamb: Ich5_p01Array<Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_lamb|Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p02_lamb>;
	readonly bg: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_bg;
	readonly hollyBack: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_hollyback;
	readonly penSide_closed: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_penside;
	readonly hollyFront: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_hollyfront;
	readonly penFront: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_penfront;
	readonly penSide_open: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p02_penside;
	readonly holly: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p02_holly;
	readonly frameRight: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_wcframeRframe;
	readonly frameLeft: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_wcframeLframe;
	readonly linesLeft: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_wcframeLlinescopy;
	readonly linesRight: Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_wcframeRlines;
}
interface Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_bg extends Ich5_p01Sprite {
}
interface Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_hollyback extends Ich5_p01Sprite {
}
interface Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_lamb extends Ich5_p01Sprite {
}
interface Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_penside extends Ich5_p01Sprite {
}
interface Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_hollyfront extends Ich5_p01Sprite {
}
interface Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p02_lamb extends Ich5_p01Sprite {
}
interface Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_penfront extends Ich5_p01Sprite {
}
interface Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p02_penside extends Ich5_p01Sprite {
}
interface Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p02_holly extends Ich5_p01Sprite {
}
interface Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_wcframeRframe extends Ich5_p01Sprite {
}
interface Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_wcframeLframe extends Ich5_p01Sprite {
}
interface Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_wcframeLlinescopy extends Ich5_p01Sprite {
}
interface Ich5_p01_hh_ch5_72dpi_p0102psdAssetchp5_p01_wcframeRlines extends Ich5_p01Sprite {
}
